import React, { useCallback } from 'react';
import toast from 'react-hot-toast';
import TrackingAPI from 'api/TrackingAPI';
import NiceModal from 'components/modals/NiceModal';
import useEnterKey from 'hooks/useKeydown';
import ls from 'local-storage';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { updateUser } from 'store/DEPRECATEDusers/asyncAction';
import styled from 'styled-components';

const ChangeNameModal = (props) => {
  const {
    isOpen,
    onClose,
    newName,
    setNewName,
    game,
    scenario,
    dialog,
    onNameChange,
    setUpdT
  } = props;

  if (!isOpen) return null;
  const dispatch = useDispatch();

  const { currentUser } = useMappedState(
    useCallback(state => {
      return {
        currentUser: state.users.usersMap.get(state.users.currentUserId),
      };
    }, [])
  );

  const analyticsData = {
    scenario: game?.alias,
    config_name: scenario?.name,
    scenario_name: game?.name,
    dialogId: dialog?.id
  };

  const handleSaveName = async () => {
    if (newName === '') return;

    TrackingAPI.trackEvent('character_name_saved', analyticsData);

    if (currentUser) {
      await dispatch(
        updateUser({
          id: currentUser?.id,
          characterName: newName
        })
      );
    }

    if (newName) {
      ls('characterName', newName);
    }

    toast.success('Character name saved');
    setUpdT(+new Date());
    onNameChange();
    onClose();
  };

  useEnterKey('Enter', handleSaveName);

  return (
    <NiceModal onClose={() => { onClose(); setNewName(currentUser?.characterName || ls.get('characterName') || ''); }}>
      <div className="flex w-full max-w-[380px] flex-col justify-center gap-y-2 p-6">
        <span className="text-center text-xl font-bold leading-6">Change name</span>
        <p className="pb-4 text-center text-base leading-5">Come up with a new name</p>
        <UserInput
          style={{ fontSize: 16, lineHeight: 18, height: 50 }}
          placeholder="Name"
          value={newName}
          onChange={evt => setNewName(evt.target.value)}
        />
        <p className="pt-2 text-center text-base leading-5 text-gray-400">
          The change will take effect only after restarting the scenario
        </p>
        <Button
          className="mt-4"
          onClick={handleSaveName}
        >
          Save
        </Button>
      </div>
    </NiceModal>
  );
};

export default ChangeNameModal;


const Button = styled.button`
background-color: rgba(255, 126, 85, 1);
box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
color: white;
padding: 8px 16px;
border-radius: 100px;
`;

const UserInput = styled.input`
  background: rgba(19, 19, 19, 1);
  border-radius: 15px;
  color: white;
  height: 60px;
  outline: none;
  padding-left: 20px;
  padding-right: 60px;
  border: 1px solid transparent;

  :focus {
    border: 1px solid rgba(255, 126, 85, 1);
    box-shadow: none !important;
  }

  ::placeholder {
    color: rgba(105, 105, 105, 1);
  }
`;